import { useState } from 'react';
export var useModal = function useModal() {
  var _useState = useState(false),
      show = _useState[0],
      toggleModal = _useState[1];

  var close = function close() {
    return toggleModal(false);
  };

  var open = function open() {
    return toggleModal(true);
  };

  var returnValue = {
    show: show,
    close: close,
    open: open
  };
  return returnValue;
};